import {
  ScheduleSettingsSlot,
  Slot,
  Status,
} from "@shared/features/agenda/types/agenda-settings.types";
import { PatientListService } from "./common/patient-list";

export class MidwifeService extends PatientListService<any> {
  constructor() {
    super("midwife");
  }

  findAllLiberals() {
    return this.api.get(`/liberals`).then((res) => res.data);
  }

  findServiceRequests() {
    return this.api.get(`/service-requests`).then((res) => res.data);
  }

  public getSchedule({ id }) {
    return this.api.get(`/user-schedule/midwife/${id}`).then((res) => res.data);
  }

  public requestScheduleAccess({ id }) {
    return this.api
      .get(`/user-schedule/midwife/${id}/request-access`)
      .then((res) => res.data);
  }

  public updateScheduleSettings({
    settings,
    id,
  }: {
    settings: {
      slots: Array<{
        start: string;
        end: string;
      }>;
      duration: number;
    };
    id?: string;
  }) {
    return this.api
      .post("/user-schedule/midwife/settings", settings, { params: { id } })
      .then((res) => res.data);
  }

  public createScheduleSlots({
    slots,
    id,
  }: {
    slots: Array<{
      start: string;
      end: string;
      status: Status;
    }>;
    id?: string;
  }) {
    return this.api
      .post("../user-schedule/midwife/slots", slots, {
        params: { id },
      })
      .then((res) => res.data);
  }

  public deleteScheduleSlots({
    slotIds,
    id,
  }: {
    slotIds: string[];
    id?: string;
  }) {
    return this.api
      .delete("../user-schedule/midwife/slots", {
        params: { id },
        data: { slotIds },
      })
      .then((res) => res.data);
  }
}
